// extracted by mini-css-extract-plugin
export var fv = "Hero-module--fv--88247";
export var hero = "Hero-module--hero--cf837";
export var hero_heading = "Hero-module--hero_heading--be839";
export var hero_img = "Hero-module--hero_img--680b8";
export var hero_img_item = "Hero-module--hero_img_item--b460e";
export var hero_img_item__inner = "Hero-module--hero_img_item__inner--cd7c1";
export var hero_link = "Hero-module--hero_link--b6d61";
export var hero_link__small = "Hero-module--hero_link__small--57424";
export var only__pc = "Hero-module--only__pc--0a01d";
export var only__sp = "Hero-module--only__sp--372d5";
export var textLink = "Hero-module--textLink--f565d";
export var textRotate = "Hero-module--textRotate--1ba26";
export var textRotate_inner = "Hero-module--textRotate_inner--bf0b2";
export var textRotate_pseudo = "Hero-module--textRotate_pseudo--41ebc";
export var textRotate_text = "Hero-module--textRotate_text--12168";